"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderPlusOneForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const PlusOneForm_1 = require("./PlusOneForm");
const RenderPlusOneForm = (props) => {
    (0, app_1.reactDOMRender)((0, jsx_runtime_1.jsx)(PlusOneForm_1.PlusOneForm, Object.assign({}, props)), props.selector);
};
exports.RenderPlusOneForm = RenderPlusOneForm;
